import { LoaderFunction } from 'react-router-dom';

// Sentry
import * as Sentry from '@sentry/react';

// GraphQL
import { client } from '../../../../../../gql/client';
import { selectCommunicationById } from '../../../../../../gql/selectors/communications';

/**
 * Loader para cargar datos de comunicación por ID directo de la comunicación
 *
 * A diferencia de LoaderGeneralViewCommunicationSummary (que usa orderId),
 * este loader recibe el communicationId directamente.
 *
 * Uso: Ruta /work-orders/communications/detail/:communicationId
 * Desde: Navegación en ShowOT (CommunicationOT component)
 */

const loadCommunicationSummaryById = async (communicationId: string) => {
  try {
    const orderCommunicationData = await selectCommunicationById(communicationId);

    return {
      ...orderCommunicationData,
      operator: `${orderCommunicationData?.userOperator.name} ${
        orderCommunicationData?.userOperator.surName.split(' ')[0]
      }`,
    };
  } catch (err) {
    Sentry.captureException(err);
    console.log('> Communication Summary By ID loading error:', err);
    return false;
  }
};

export const LoaderCommunicationById: LoaderFunction = async ({ params }) => {
  // El trabajo entero vive aquí dentro, íntegro. Solo ha dejado de
  // esperarse: la promesa tiene que llegar PENDIENTE al `<Await>` para que
  // el router termine la navegación al instante y el `<Fallback>` enseñe el
  // Loader DENTRO de la pantalla nueva.
  const load = async () => {
  if (!params.communicationId) return null;
  if (Object.keys(client.cache.extract()).length === 0) return null;

  const loaderToResolve = loadCommunicationSummaryById(params.communicationId);
  return loaderToResolve;
};

  return { data: load() };
};
